import { SiteProjectTable, ProjectDetailsPage } from "./ProjectsTables";
import { TaskActivtyDetailsPage } from "./ProjectsDisplay";

const allProjectsRoutes = [
  {
    path: "",
    component: <SiteProjectTable />,
  },
  {
    path: "projectsList",
    component: <SiteProjectTable />,
  },
  {
    path: "projectDetailsPage",
    component: <ProjectDetailsPage />,
  },
  {
    path: "projectTaskActivities",
    component: <TaskActivtyDetailsPage />,
  },
];

const ProjectsListRoute = {
  path: "projectsList",
  component: <SiteProjectTable />,
};

const ProjectDetailPageRoute = {
  path: "projectDetailsPage",
  component: <ProjectDetailsPage />,
};

const TaskActivtyDetailsPageRoute = {
  path: "projectTaskActivities",
  component: <TaskActivtyDetailsPage />,
};

export default allProjectsRoutes;

export { ProjectsListRoute, ProjectDetailPageRoute, TaskActivtyDetailsPageRoute };
